import React from 'react';
import { InstantSubmitOrCancel } from '../../InstantSubmitOrCancel/InstantSubmitOrCancel';
import { FormContainerModifier } from '../../../molecules/Form';
import { InstantInteraction, ViewsType } from '../BlockInteractionsTypes';

type BlockInteractionsInstantInteractionType = {
  views: ViewsType;
  instantInteraction?: InstantInteraction;
};

export function BlockInteractionsInstantInteraction({
  views,
  instantInteraction,
}: BlockInteractionsInstantInteractionType) {
  if (instantInteraction && views[instantInteraction.key]) {
    return (
      <div className="block-interactions__instant-interaction">
        <InstantSubmitOrCancel
          containerModifier={FormContainerModifier.NO_PADDING_TOP}
          transnamespace={instantInteraction.transnamespace}
          model={views[instantInteraction.key]?.embedded.form}
          approveAction={views[instantInteraction.key]?.embedded.form.actions.accept}
          rejectAction={views[instantInteraction.key]?.embedded.form.actions.reject}
        />
      </div>
    );
  }
  return null;
}
